module.exports = __webpack_public_path__ + "static/media/Sushi.40e91f04.svg";